export default __webpack_public_path__ + "static/media/loading-img.bd089314.svg";